export const KINDS = {
    Primary: 'primary',
    Secondary: 'secondary',
    Danger: 'danger',
    Ghost: 'ghost',
    GhostDanger: 'ghost-danger',
    Link: 'link',
};
export const STATES = {
    Disabled: 'disabled',
    Enabled: 'enabled',
    Loading: 'loading',
};
export const SIZES = {
    Small: 'small',
    Medium: 'medium',
    Big: 'big',
};
